import {mapGetters, mapMutations, mapActions} from 'vuex'

import _ from 'lodash'
import reviewImg from '@/components/review-img/index.vue'

export default {
  name: 'paymnet',
  //---components
  components: {
    reviewImg
  },
  //---data
  data () {
    return {
      stripeData: {
        firstName: null,
        lastName: null,
        zip: null
      },
      stripeObject: null,
      stripeElements: {
        cardNumber: null,
        cardExpiry: null,
        cardCvc: null,
      },
      stripeToken: null,
      isValidPaymentForm: true,
      isStripeInit: false,
      paymentErrorText: null
    }
  },
  //---hooks
  created: function () {
    if (!this.analysis) {
      this.$router.push({name: 'searchProperty'});
    } else {
      if (this.contacts) {
        this.stripeData.firstName = this.contacts.firstName;
        this.stripeData.lastName = this.contacts.lastName;
      }
    }
  },
  mounted: function () {
    if (this.analysis) {
      this._initStripe();
    }
  },
  computed: {
    ...mapGetters({
      content: 'APP/content',
      analysis: 'ANALYSIS/analysis',
      contacts: 'CONTACTS/contacts',
      client: 'CLIENT/client',
      userPayment: 'CLIENT/userPayment',
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      chargeUser: 'CLIENT/CLIENT_USER_CHARGE_REQUEST_SET',
    }),
    _initStripe() {
      //---create a stripe object
      this.stripeObject = window.Stripe(this.client.paymentGatewayPublicKey);
      //---create elements.
      let elements = this.stripeObject.elements();

      //---custom style for elements
      let elementStyles = {
        base: {
          color: '#303133',
          fontWeight: 500,
          fontFamily: '"Roboto","Helvetica Neue", Helvetica, sans-serif',
          fontSize: '14px',
          lineHeight: '34px',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#8D8D8F',
          },
          ':-webkit-autofill': {
            color: '#303133',
          },
        },
        invalid: {
          color: '#303133',
          '::placeholder': {
            color: '#303133'
          },
        },
        valid: {
          color: '#303133',
          '::placeholder': {
            color: '#303133'
          },
        },
      };

      this.stripeElements.cardNumber = elements.create('cardNumber', {
        style: elementStyles
      });
      this.stripeElements.cardNumber.mount('#payment-card-element-number');

      this.stripeElements.cardExpiry = elements.create('cardExpiry', {
        style: elementStyles
      });
      this.stripeElements.cardExpiry.mount('#payment-card-element-expiry');

      this.stripeElements.cardCvc = elements.create('cardCvc', {
        style: elementStyles
      });
      this.stripeElements.cardCvc.mount('#payment-card-element-cvc');
      //---real-time validation errors
      this.stripeElements.cardNumber.addEventListener('change', event => {
        if (event.error) {
          this.paymentErrorText = event.error.message;
        } else {
          this.paymentErrorText = null;
        }
      });
      setTimeout(()=>{
        this.isStripeInit = true;
      },1000)
    },
    purchaseAnalysis() {
      this.$refs.paymentForm.validate();
      if (this.isValidPaymentForm) {
        this.stripeObject.createToken(this.stripeElements.cardNumber, {
          address_zip: this.stripeData.zip,
          name: this.stripeData.firstName + ' ' + this.stripeData.lastName
        }).then(result => {
          if (result.error) {
            this.paymentErrorText = result.error.message;
          } else {
            this.loaderFlag(true);
            this.stripeToken = result.token;
            this.paymentErrorText = null;

            this.chargeUser({
              clientId: this.client.userId,
              userId: this.userPayment.id,
              payload: {
                payeeFirstName: this.stripeToken.card.name.split(' ')[0],
                payeeLastName: this.stripeToken.card.name.split(' ')[1],
                expirationMonth: this.stripeToken.card.exp_month,
                expirationYear: this.stripeToken.card.exp_year,
                paymentProviderToken: this.stripeToken.id,
                zipCode: parseInt(this.stripeToken.card.address_zip),
                amountBilled: this.client.analysisFee,
                cartId: this.userPayment.cart.id,
              }
            }).then(()=>{
              this.$router.push({name: 'analysis'});
            }).catch( error => {
              this.$snotify.error(error);
            }).finally(()=>{
              this.loaderFlag(false);
            });

          }
        });

      } else if (!this.isValidPaymentForm && !this.$refs.firstName.valid) {
        this.paymentErrorText = 'Your first name is empty.';
      } else if (!this.isValidPaymentForm && !this.$refs.lastName.valid) {
        this.paymentErrorText = 'Your last name is empty';
      } else if (!this.isValidPaymentForm && !this.$refs.zip.valid) {
        this.paymentErrorText = 'Your ZIP code is incomplete.';
      }
    },
    validateForm() {
      this.$refs.paymentForm.validate();
      if (this.isValidPaymentForm) {
        this.paymentErrorText = null;
      } else if (!this.isValidPaymentForm && !this.$refs.firstName.valid) {
        this.paymentErrorText = 'Your first name is empty.';
      } else if (!this.isValidPaymentForm && !this.$refs.lastName.valid) {
        this.paymentErrorText = 'Your last name is empty';
      } else if (!this.isValidPaymentForm && !this.$refs.zip.valid) {
        this.paymentErrorText = 'Your ZIP code is incomplete.';
      }
    }
  }
}
